import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles/Icon.module.css';

interface IconProps {
  icon: IconDefinition;
  // Twice the size of the text around it, as for the menu buttons
  size?: '2x';
}

// A Font Awesome icon drawn as plain SVG, sized like Font Awesome's own, without
// loading its JavaScript and CSS
const Icon = ({ icon, size }: IconProps) => {
  const [width, height, , , path] = icon.icon;
  return (
    <svg
      className={styles.icon}
      data-size={size}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      focusable="false"
    >
      <path fill="currentColor" d={Array.isArray(path) ? path.join(' ') : path} />
    </svg>
  );
};

export default Icon;
